import React from 'react';
import styled, { css } from 'styled-components/macro';
import constantes from '../../resources/constantes.json';
const ImgCandidatoConsulta = ({ codpar, codcan, width, height, ...rest }) => {
  let basename = `${constantes.rutas.candidatos}${codcan.padStart(3, '0')}-${codpar.padStart(4, '0')}`;

  return (
     <ContenedorLogos width={width} height={height}>
      <LogoImg
        src={`${basename}.png`}
        alt="Imagen candidato"
        {...rest}
      />
    </ContenedorLogos>
  );
};
export default ImgCandidatoConsulta;

const ContenedorLogos = styled.div`
  width: 80px;
  height: 80px;
  position: relative;
  display: inline-block;
`;

const LogoImg = styled.img`
  position: absolute;
  width: 70px;
`;

